import axios from 'axios';
import { evolve, toString } from 'ramda';
import { fulfilled } from '../utils/helpers';

const initialState = [];

export const types = {
  FETCH_CITIES: 'FETCH_CITIES',
};

// FIXME: data.data
export const fetchCities = () => ({
  type: types.FETCH_CITIES,
  payload: axios
    .get('/cities')
    .then(response => response.data.data.map(evolve({ id: toString }))),
});

export default (state = initialState, { type, payload }) =>
  fulfilled(types.FETCH_CITIES) === type ? payload : state;

export const getCities = state => state.cities;



// WEBPACK FOOTER //
// ./src/reducers/cities.js